import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, AxiosError } from "axios"
import { useState } from "react";
import { HttpCode } from "./enums";
import { errorNotify } from "./toast";

function setLoadRequest(v:boolean){
  let element = document.getElementById("load-request");
  let masterpage = document.getElementById("masterpage");
  if(element != null)
    element.style.display = v?"block":"none";
  
  if(masterpage != null)
    masterpage.style.overflow = v?"hidden":"";
}

function setLoadRequestOk(v:boolean){
  let load = document.getElementById("lds-ellipsis");
  let correct = document.getElementById("correct-icon");
  if(load != null)
    load.style.display = v?"none":"";
  
  if(correct != null)
    correct.style.display = v?"":"none";
}

class Api{
  api: AxiosInstance;
  
  constructor(){
    this.api = axios.create({
      baseURL: process.env.REACT_APP_URL_API,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      }
    })
    this._prepare_api();
  }
  _prepare_api(){
    this.api.interceptors.request.use((config: any) => {
      if (localStorage.getItem("sim.t2b:token")) {
        let token = localStorage.getItem("sim.t2b:token");
        if(token && token !== "null"){
          
          let token_obj = JSON.parse(token);
          config.headers.Authorization = `Bearer ${token_obj.access_token}`;
        }
      }
      return config
    }, error => {
      return Promise.reject(error)
    })

    this.api.interceptors.response.use(response => {
      return response.data
    }, this._error)
  }
  _error(error: AxiosError){
    if(axios.isCancel(error)){
      return Promise.reject({cancel:true})
    }

    if(error.response && error.response.status){
      let status = error.response.status;
      // console.log(error.response.status);
      if(status === HttpCode.FORBIDDEN){
        let messageError = [
          "Token is Invalid",
          "Token is Expired",
          "Authorization Token not found"
        ];
        let data = error.response.data;
        if(data.message && messageError.indexOf(data.message) !== -1){
          /* TOKEN INVALIDO */
          localStorage.clear();
          window.location.reload();
        }
      }

      if (status === HttpCode.UNPROCESSABLE_ENTITY) {
        const { message } = error.response.data
        message.forEach((m: string) => {
          errorNotify(m)
        });
      }

      if (status === HttpCode.SERVER_ERROR) {
        const { message } = error.response.data
        errorNotify(message, 'top-center')
      }
    }
    
    return Promise.reject(error)
  }
  post<T = any, R = AxiosResponse<T, any>, D = any>(url: string, data?: D, config?: AxiosRequestConfig<D>): Promise<R> {
    return this.api.post<T, R, D>(url,data,config);
  }
  getUri(config?: AxiosRequestConfig<any>): string {
    return this.api.getUri(config);
  }
  request<T = any, R = AxiosResponse<T, any>, D = any>(config: AxiosRequestConfig<D>): Promise<R> {
    return this.api.request<T, R, D>(config);
  }
  get<T = any, R = AxiosResponse<T, any>, D = any>(url: string, config?: AxiosRequestConfig<D>): Promise<R> {
    return this.api.get<T, R, D>(url,config);
  }
  delete<T = any, R = AxiosResponse<T, any>, D = any>(url: string, config?: AxiosRequestConfig<D>): Promise<R> {
    return this.api.delete<T, R, D>(url,config);
  }
  head<T = any, R = AxiosResponse<T, any>, D = any>(url: string, config?: AxiosRequestConfig<D>): Promise<R> {
    return this.api.head<T, R, D>(url,config);
  }
  options<T = any, R = AxiosResponse<T, any>, D = any>(url: string, config?: AxiosRequestConfig<D>): Promise<R> {
    return this.api.options<T, R, D>(url,config);
  }
  put<T = any, R = AxiosResponse<T, any>, D = any>(url: string, data?: D, config?: AxiosRequestConfig<D>): Promise<R> {
    return this.api.put<T, R, D>(url,data,config);
  }
  patch<T = any, R = AxiosResponse<T, any>, D = any>(url: string, data?: D, config?: AxiosRequestConfig<D>): Promise<R> {
    return this.api.patch<T, R, D>(url,data,config);
  }
  postLoad<T = any, R = AxiosResponse<T, any>, D = any>(url: string, data?: D, config?: AxiosRequestConfig<D>): Promise<R> {
    return new Promise(async (yes,no)=>{
      setLoadRequest(true);
      setLoadRequestOk(false);
      try {
        let res:R = await this.api.post<T, R, D>(url,data,config);
        yes(res);
        setTimeout(()=>setLoadRequestOk(true),300);
        setTimeout(()=>setLoadRequest(false),2000);
      } catch (error) {
        setLoadRequest(false);
        no(error);
      }
    });
  };
}

export default Api;
export const api = new Api();

export function createCancelToken(){
  var CancelToken = axios.CancelToken;
  let source = CancelToken.source();
  const { token, cancel } = source;
  return { token, cancel };
}

export function useCancelToken(){
  const [ c ] = useState(createCancelToken());

  return {
    token: c.token,
    cancel: c.cancel
  }
}

export interface IPagination{
  current_page: number;
  from: number;
  last_page: number;
  next_page: null;
  per_page: number;
  to: number;
  total: number;
}

export async function renderFile(url:string){
  let api = axios.create({
    baseURL: "http://drive.google.com/viewerng/",
  })
  let response = await api.get("viewer",{params:{
    embedded: true,
    url: url
  }})

  return response.data;
}